@if (author) {
  <div class="et-author-entry-container mb-4">
    <div class="et-author-email-row flex">
      <span class="align-self-center ml-6 et-author-email">{{ author.email }}</span>
      <i class="fas fa-trash ml-auto align-self-center mr-5"
         (click)="removeAuthor()"
         tooltipPosition="top"
         pTooltip="Click to remove author"
         i18n-pTooltip></i>
    </div>
    <form [formGroup]="form">
      <div class="formgrid grid mt-3 mx-6">
        <div class="field col-6 mt-3">
          <label for="firstName"
                 class="font-bold"
                 [ngClass]="{ 'sc-required-input' : !isReadonly }"
                 i18n>
            First Name</label>
          <input scValidatable
                 id="firstName"
                 type="text"
                 pInputText
                 formControlName="firstName"
                 [placeholder]="isReadonly ? '' : 'Enter first name'"
                 i18n-placeholder
                 class="w-full">
        </div>
        <div class="field col-6 mt-3">
          <label for="countryId"
                 class="font-bold"
                 [ngClass]="{ 'sc-required-input' : !isReadonly }"
                 i18n>Country</label>
          <p-select scValidatable
                    id="countryId"
                    [options]="countries$ | async"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="50"
                    [showClear]="true"
                    formControlName="countryId"
                    [placeholder]="isReadonly ? '' : 'Choose country'"
                    [filter]="true"
                    i18n-placeholder
                    styleClass="w-full">
          </p-select>
        </div>
        <div class="field col-6 mt-3">
          <label for="lastName"
                 class="font-bold"
                 [ngClass]="{ 'sc-required-input' : !isReadonly }"
                 i18n>Last Name</label>
          <input scValidatable
                 id="lastName"
                 type="text"
                 pInputText
                 formControlName="lastName"
                 [placeholder]="isReadonly ? '' : 'Enter last name'"
                 i18n-placeholder
                 class="w-full">
        </div>
        <div class="field col-6 mt-3">
          <label for="universityOrOrganization"
                 class="font-bold"
                 [ngClass]="{ 'sc-required-input' : !isReadonly }"
                 i18n>
            University/Organization</label>
          <sc-grid-autocomplete inputId="universityOrOrganization"
                                scValidatable
                                formControlName="universityOrOrganization"
                                [placeholder]="isReadonly ? '' : 'Find university/organization'"
                                (organizationSelected)="fillAddressFromGrid($event)"
                                inputStyleClass="w-full"
                                styleClass="w-full">
          </sc-grid-autocomplete>
        </div>
        <div class="field col-6 mt-3">
          <label for="title"
                 class="font-bold"
                 i18n>Title</label>
          <p-select id="title"
                    [options]="titles$ | async"
                    [showClear]="true"
                    formControlName="title"
                    [placeholder]="isReadonly ? '' : 'Choose title'"
                    i18n-placeholder
                    styleClass="w-full">
          </p-select>
        </div>
        <div class="field col-6 mt-3">
          <label for="orcidId"
                 class="font-bold"
                 i18n>ORCID iD</label>
          <p-inputMask mask="9999-9999-9999-999a"
                       characterPattern="[0-9X]"
                       id="orcidId"
                       scValidatable
                       formControlName="orcidId"
                       [placeholder]="isReadonly ? '' : 'Enter ORCID iD, e.g. 0000-0002-1825-0097'"
                       i18n-placeholder
                       styleClass="w-full">
          </p-inputMask>
        </div>
        <div class="col-12 mb-2 flex justify-content-between">
          <div>
            @if (isEmailUnused) {
              <p-message severity="error"
                         text=" Author already exists in the table."
                         class="warning-message subtitle3Font"
                         i18n-text>
              </p-message>
            }
          </div>
          <p-button scSubmitButton
                    [requestInProcess]="requestInProcess"
                    (onClick)="addAuthor()"
                    styleClass="p-button-text"
                    icon="pi pi-plus"
                    iconPos="left"
                    label="Add author to the table"
                    i18n-label>
          </p-button>
        </div>
      </div>
    </form>
  </div>
}